// Type definitions for photo zones
export type PhotoZoneType = 
  | 'techo'
  | 'frontal'
  | 'frontal-derecho'
  | 'lateral-derecho'
  | 'trasero-derecho'
  | 'trasero'
  | 'trasero-izquierdo'
  | 'lateral-izquierdo'
  | 'frontal-izquierdo'
  | 'full-covering'
  | 'cabina-interior-general'
  | 'cuadro-cabina-activado'
  | 'monitor-olympus'
  | 'montaje-monitor-cabina'
  | 'pantalla-gsr2'
  | 'llave-armario-electrico'
  | 'libros-uso-mantenimiento'
  | 'salpicadero-zona-guantera'
  | 'zona-salpicadero-sin-rayas'
  | 'sistema-pesaje'
  | 'bomba1'
  | 'caja-cabina-izq-inferior'
  | 'caja-cabina-izq-medio'
  | 'caja-cabina-izq-superior'
  | 'nivel-aceite'
  | 'pegatina-tipo-aceite'
  | 'lateral-anterior-izquierdo-zona1-inferior'
  | 'lateral-anterior-izquierdo-zona1-media'
  | 'lateral-anterior-izquierdo-zona1-superior'
  | 'lateral-anterior-izquierdo-zona2-inferior'
  | 'lateral-anterior-izquierdo-zona2-media'
  | 'lateral-anterior-izquierdo-zona2-superior'
  | 'lateral-anterior-izquierdo-zona3-inferior'
  | 'lateral-anterior-izquierdo-zona3-media'
  | 'lateral-anterior-izquierdo-zona3-superior'
  | 'lateral-anterior-izquierdo-zona4-inferior'
  | 'lateral-anterior-izquierdo-zona4-media'
  | 'lateral-anterior-izquierdo-zona4-superior'
  | 'lateral-tailgate-izquierdo-entero'
  | 'zona-posterior-izquierda-inferior'
  | 'zona-posterior-izquierda-media'
  | 'zona-posterior-izquierda-superior'
  | 'identificacion-elevador'
  | 'zona-posterior-centrada-inferior'
  | 'zona-posterior-centrada-media'
  | 'zona-posterior-centrada-superior'
  | 'zona-interior-tolva-inferior'
  | 'zona-interior-tolva-superior-izquierdo'
  | 'zona-interior-tolva-superior-derecho'
  | 'zona-posterior-derecha-inferior'
  | 'zona-posterior-derecha-media'
  | 'zona-posterior-derecha-superior'
  | 'lateral-tailgate-derecho-entero'
  | 'lateral-anterior-derecho-zona4-inferior'
  | 'lateral-anterior-derecho-zona4-media'
  | 'lateral-anterior-derecho-zona4-superior'
  | 'lateral-anterior-derecho-zona3-inferior'
  | 'lateral-anterior-derecho-zona3-media'
  | 'lateral-anterior-derecho-zona3-superior'
  | 'lateral-anterior-derecho-zona2-inferior'
  | 'lateral-anterior-derecho-zona2-media'
  | 'lateral-anterior-derecho-zona2-superior'
  | 'lateral-anterior-derecho-zona1-inferior'
  | 'lateral-anterior-derecho-zona1-media'
  | 'lateral-anterior-derecho-zona1-superior'
  | 'caja-cabina-derecha-inferior'
  | 'caja-cabina-derecha-medio'
  | 'caja-cabina-derecha-superior'
  | 'pegatina-tara'
  | 'pegatina-altura-maxima'
  | 'pegatina-revision-extintor'
  | 'pegatina-idioma-extintor'
  | 'otros'
  | 'plc-lado-izquierdo'
  | 'plc-lado-derecho'
  | 'otros-cabin'
  | 'otros-bomba'
  | 'otros-caja-cabina-izquierda'
  | 'otros-lateral-izquierdo-zona1'
  | 'otros-lateral-izquierdo-zona2'
  | 'otros-lateral-izquierdo-zona3'
  | 'otros-lateral-izquierdo-zona4'
  | 'otros-tailgate-izquierdo'
  | 'otros-posterior-izquierdo'
  | 'otros-posterior-centrado'
  | 'otros-posterior-derecho'
  | 'otros-tailgate-derecho'
  | 'otros-lateral-derecho-zona4'
  | 'otros-lateral-derecho-zona3'
  | 'otros-lateral-derecho-zona2'
  | 'otros-lateral-derecho-zona1'
  | 'otros-caja-cabina-derecha'
  | 'otros-pegatinas'
  | 'otros-tailgate-abierto'
  | 'foto-junta-de-estanqueidad'
  | 'foto-eyectora-en-interior-de-caja'
  | 'foto-eyectora-pasante'
  | 'foto-trineo-parte-interior-posicion-baja'
  | 'foto-general-lateral-tailgate-abierto';

export interface PhotoZone {
  type: PhotoZoneType;
  label: string;
  id: string;
  mandatory: boolean;
  multiple: boolean;
  qualityCheck: boolean;
}

export interface PhotoGroup {
  id: string;
  label: string;
  photos: PhotoZone[];
}

export type TranslationFunction = (key: string) => string;

export const getPhotoGroups = (t: TranslationFunction): PhotoGroup[] => [
    {
      id: "Fotos generales / General photos",
      label: t('capture.generalPhotos'),
      photos: [
        {
          type: 'techo' as const,
          label: t('photoZones.techo'),
          id: "Techo",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'frontal' as const,
          label: t('photoZones.frontal'),
          id: "Delantera",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'frontal-derecho' as const,
          label: t('photoZones.frontalDerecho'),
          id: "Delantera Derecha",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'lateral-derecho' as const,
          label: t('photoZones.lateralDerecho'),
          id: "Derecha",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'trasero-derecho' as const,
          label: t('photoZones.traseroDerecho'),
          id: "Trasera Derecha",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'trasero' as const,
          label: t('photoZones.trasero'),
          id: "Trasera",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'trasero-izquierdo' as const,
          label: t('photoZones.traseroIzquierdo'),
          id: "Trasera Izquierda",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'lateral-izquierdo' as const,
          label: t('photoZones.lateralIzquierdo'),
          id: "Izquierda",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'frontal-izquierdo' as const,
          label: t('photoZones.frontalIzquierdo'),
          id: "Delantera Izquierda",
          mandatory: true,
          multiple: false,
          qualityCheck: true,
        },
        {
          type: 'full-covering' as const,
          label: t('photoZones.fullCovering'),
          id: "Full Covering",
          mandatory: false,
          multiple: true,
          qualityCheck: true,
        },
      ],
    },
    {
      id: "Fotos Cabina / Cabin Photos",
      label: t('capture.cabinPhotos'),
      photos: [
        {
          type: 'cabina-interior-general' as const,
          label: t('photoZones.cabinaInteriorGeneral'),
          id: "Cabina Interior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'cuadro-cabina-activado' as const,
          label: t('photoZones.cuadroCabinaActivado'),
          id: "Cuadro Cabina Activado",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'monitor-olympus' as const,
          label: t('photoZones.monitorOlympus'),
          id: "Cabina Monitor Olympus",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'montaje-monitor-cabina' as const,
          label: t('photoZones.montajeMonitorCabina'),
          id: "Montaje Monitor En Cabina",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'pantalla-gsr2' as const,
          label: t('photoZones.pantallaGsr2'),
          id: "Cabina Pantalla GSR 2",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'llave-armario-electrico' as const,
          label: t('photoZones.llaveArmarioElectrico'),
          id: "Cabina Llave Armario Electrico",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'libros-uso-mantenimiento' as const,
          label: t('photoZones.librosUsoMantenimiento'),
          id: "Cabina Libros de Instrucciones",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'salpicadero-zona-guantera' as const,
          label: t('photoZones.salpicaderoZonaGuantera'),
          id: "Cabina Guantera",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-salpicadero-sin-rayas' as const,
          label: t('photoZones.zonaSalpicaderoSinRayas'),
          id: "Cabina Salpicadero",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'sistema-pesaje' as const,
          label: t('photoZones.sistemaPesaje'),
          id: "Cabina Sistema de Pesaje",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-cabin' as const,
          label: t('photoZones.otrosCabina'),
          id: "Otros Cabina",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Bomba / Pump Photos",
      label: t('capture.bombaPhotos'),
      photos: [
        {
          type: 'bomba1' as const,
          label: t('photoZones.bomba1'),
          id: "Bomba",
          mandatory: true,
          multiple: true,
          qualityCheck: false,
        },
        {
          type: 'otros-bomba' as const,
          label: t('photoZones.otrosBomba'),
          id: "Otros Bomba",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Entre Caja y Cabina - Lado Izquierdo / Photos Between Body and Cabin - Left Side",
      label: t('capture.cajaCabinaIzquierdoPhotos'),
      photos: [
        {
          type: 'caja-cabina-izq-inferior' as const,
          label: t('photoZones.cajaCabinaIzqInferior'),
          id: "Caja Cabina Izquierdo Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'caja-cabina-izq-medio' as const,
          label: t('photoZones.cajaCabinaIzqMedio'),
          id: "Caja Cabina Izquierdo Medio",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'caja-cabina-izq-superior' as const,
          label: t('photoZones.cajaCabinaIzqSuperior'),
          id: "Caja Cabina Izquierdo Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'nivel-aceite' as const,
          label: t('photoZones.nivelAceite'),
          id: "Nivel de Aceite",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'pegatina-tipo-aceite' as const,
          label: t('photoZones.pegatinaTipoAceite'),
          id: "Pegatina Tipo Aceite",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-caja-cabina-izquierda' as const,
          label: t('photoZones.otrosCajaCabinaIzquierda'),
          id: "Otros Caja Cabina Izquierda",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Izquierdo Zona 1 / Left Side Photos Zone 1",
      label: t('capture.lateralIzquierdoZona1Photos'),
      photos: [
        {
          type: 'lateral-anterior-izquierdo-zona1-inferior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona1Inferior'),
          id: "Lateral Anterior Izquierdo Zona 1 Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona1-media' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona1Media'),
          id: "Lateral Anterior Izquierdo Zona 1 Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona1-superior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona1Superior'),
          id: "Lateral Anterior Izquierdo Zona 1 Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'plc-lado-izquierdo' as const,
          label: t('photoZones.plcLadoIzquierdo'),
          id: "PLC Lado Izquierdo",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-izquierdo-zona1' as const,
          label: t('photoZones.otrosLateralIzquierdoZona1'),
          id: "Otros Lateral Izquierdo Zona 1",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Izquierdo Zona 2 / Left Side Photos Zone 2",
      label: t('capture.lateralIzquierdoZona2Photos'),
      photos: [
        {
          type: 'lateral-anterior-izquierdo-zona2-inferior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona2Inferior'),
          id: "Lateral Anterior Izquierdo Zona 2 Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona2-media' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona2Media'),
          id: "Lateral Anterior Izquierdo Zona 2 Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona2-superior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona2Superior'),
          id: "Lateral Anterior Izquierdo Zona 2 Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-izquierdo-zona2' as const,
          label: t('photoZones.otrosLateralIzquierdoZona2'),
          id: "Otros Lateral Izquierdo Zona 2",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Izquierdo Zona 3 / Left Side Photos Zone 3",
      label: t('capture.lateralIzquierdoZona3Photos'),
      photos: [
        {
          type: 'lateral-anterior-izquierdo-zona3-inferior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona3Inferior'),
          id: "Lateral Anterior Izquierdo Zona 3 Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona3-media' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona3Media'),
          id: "Lateral Anterior Izquierdo Zona 3 Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona3-superior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona3Superior'),
          id: "Lateral Anterior Izquierdo Zona 3 Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-izquierdo-zona3' as const,
          label: t('photoZones.otrosLateralIzquierdoZona3'),
          id: "Otros Lateral Izquierdo Zona 3",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Izquierdo Zona 4 / Left Side Photos Zone 4",
      label: t('capture.lateralIzquierdoZona4Photos'),
      photos: [
        {
          type: 'lateral-anterior-izquierdo-zona4-inferior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona4Inferior'),
          id: "Lateral Anterior Izquierdo Zona 4 Inferior",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona4-media' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona4Media'),
          id: "Lateral Anterior Izquierdo Zona 4 Media",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-izquierdo-zona4-superior' as const,
          label: t('photoZones.lateralAnteriorIzquierdoZona4Superior'),
          id: "Lateral Anterior Izquierdo Zona 4 Superior",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-izquierdo-zona4' as const,
          label: t('photoZones.otrosLateralIzquierdoZona4'),
          id: "Otros Lateral Izquierdo Zona 4",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Tailgate Izquierdo / Left Tailgate Photos",
      label: t('capture.tailgateIzquierdoPhotos'),
      photos: [
        {
          type: 'lateral-tailgate-izquierdo-entero' as const,
          label: t('photoZones.lateralTailgateIzquierdoEntero'),
          id: "Elevador Lateral Izquierdo",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-tailgate-izquierdo' as const,
          label: t('photoZones.otrosTailgateIzquierdo'),
          id: "Otros Tailgate Izquierdo",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Posterior Izquierdo / Rear Left Photos",
      label: t('capture.posteriorIzquierdoPhotos'),
      photos: [
        {
          type: 'zona-posterior-izquierda-inferior' as const,
          label: t('photoZones.zonaPosteriorIzquierdaInferior'),
          id: "Posterior Izquierda Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-izquierda-media' as const,
          label: t('photoZones.zonaPosteriorIzquierdaMedia'),
          id: "Posterior Izquierda Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-izquierda-superior' as const,
          label: t('photoZones.zonaPosteriorIzquierdaSuperior'),
          id: "Posterior Izquierda Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-posterior-izquierdo' as const,
          label: t('photoZones.otrosPosteriorIzquierdo'),
          id: "Otros Posterior Izquierdo",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Posterior Centrado / Rear Center Photos",
      label: t('capture.posteriorCentradoPhotos'),
      photos: [
        {
          type: 'identificacion-elevador' as const,
          label: t('photoZones.identificacionElevador'),
          id: "Identificacion Elevador",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-centrada-inferior' as const,
          label: t('photoZones.zonaPosteriorCentradaInferior'),
          id: "Posterior Centrada Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-centrada-media' as const,
          label: t('photoZones.zonaPosteriorCentradaMedia'),
          id: "Posterior Centrada Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-centrada-superior' as const,
          label: t('photoZones.zonaPosteriorCentradaSuperior'),
          id: "Posterior Centrada Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-interior-tolva-inferior' as const,
          label: t('photoZones.zonaInteriorTolvaInferior'),
          id: "Interior Tolva Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-interior-tolva-superior-izquierdo' as const,
          label: t('photoZones.zonaInteriorTolvaSuperiorIzquierdo'),
          id: "Interior Tolva Superior Izquierdo",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-interior-tolva-superior-derecho' as const,
          label: t('photoZones.zonaInteriorTolvaSuperiorDerecho'),
          id: "Interior Tolva Superior Derecho",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-posterior-centrado' as const,
          label: t('photoZones.otrosPosteriorCentrado'),
          id: "Otros Posterior Centrado",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Posterior Derecho / Rear Right Photos",
      label: t('capture.posteriorDerechoPhotos'),
      photos: [
        {
          type: 'zona-posterior-derecha-inferior' as const,
          label: t('photoZones.zonaPosteriorDerechaInferior'),
          id: "Posterior Derecha Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-derecha-media' as const,
          label: t('photoZones.zonaPosteriorDerechaMedia'),
          id: "Posterior Derecha Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'zona-posterior-derecha-superior' as const,
          label: t('photoZones.zonaPosteriorDerechaSuperior'),
          id: "Posterior Derecha Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-posterior-derecho' as const,
          label: t('photoZones.otrosPosteriorDerecho'),
          id: "Otros Posterior Derecho",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Tailgate Derecho / Right Tailgate Photos",
      label: t('capture.tailgateDerechoPhotos'),
      photos: [
        {
          type: 'lateral-tailgate-derecho-entero' as const,
          label: t('photoZones.lateralTailgateDerechoEntero'),
          id: "Elevador Lateral Derecho",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-tailgate-derecho' as const,
          label: t('photoZones.otrosTailgateDerecho'),
          id: "Otros Tailgate Derecho",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Derecho Zona 4 / Right Side Photos Zone 4",
      label: t('capture.lateralDerechoZona4Photos'),
      photos: [
        {
          type: 'lateral-anterior-derecho-zona4-inferior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona4Inferior'),
          id: "Lateral Anterior Derecho Zona 4 Inferior",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona4-media' as const,
          label: t('photoZones.lateralAnteriorDerechoZona4Media'),
          id: "Lateral Anterior Derecho Zona 4 Media",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona4-superior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona4Superior'),
          id: "Lateral Anterior Derecho Zona 4 Superior",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-derecho-zona4' as const,
          label: t('photoZones.otrosLateralDerechoZona4'),
          id: "Otros Lateral Derecho Zona 4",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Derecho Zona 3 / Right Side Photos Zone 3",
      label: t('capture.lateralDerechoZona3Photos'),
      photos: [
        {
          type: 'lateral-anterior-derecho-zona3-inferior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona3Inferior'),
          id: "Lateral Anterior Derecho Zona 3 Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona3-media' as const,
          label: t('photoZones.lateralAnteriorDerechoZona3Media'),
          id: "Lateral Anterior Derecho Zona 3 Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona3-superior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona3Superior'),
          id: "Lateral Anterior Derecho Zona 3 Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-derecho-zona3' as const,
          label: t('photoZones.otrosLateralDerechoZona3'),
          id: "Otros Lateral Derecho Zona 3",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Derecho Zona 2 / Right Side Photos Zone 2",
      label: t('capture.lateralDerechoZona2Photos'),
      photos: [
        {
          type: 'lateral-anterior-derecho-zona2-inferior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona2Inferior'),
          id: "Lateral Anterior Derecho Zona 2 Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona2-media' as const,
          label: t('photoZones.lateralAnteriorDerechoZona2Media'),
          id: "Lateral Anterior Derecho Zona 2 Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona2-superior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona2Superior'),
          id: "Lateral Anterior Derecho Zona 2 Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-derecho-zona2' as const,
          label: t('photoZones.otrosLateralDerechoZona2'),
          id: "Otros Lateral Derecho Zona 2",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Lateral Derecho Zona 1 / Right Side Photos Zone 1",
      label: t('capture.lateralDerechoZona1Photos'),
      photos: [
        {
          type: 'lateral-anterior-derecho-zona1-inferior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona1Inferior'),
          id: "Lateral Anterior Derecho Zona 1 Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona1-media' as const,
          label: t('photoZones.lateralAnteriorDerechoZona1Media'),
          id: "Lateral Anterior Derecho Zona 1 Media",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'lateral-anterior-derecho-zona1-superior' as const,
          label: t('photoZones.lateralAnteriorDerechoZona1Superior'),
          id: "Lateral Anterior Derecho Zona 1 Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'plc-lado-derecho' as const,
          label: t('photoZones.plcLadoDerecho'),
          id: "PLC Lado Derecho",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-lateral-derecho-zona1' as const,
          label: t('photoZones.otrosLateralDerechoZona1'),
          id: "Otros Lateral Derecho Zona 1",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Entre Caja y Cabina - Lado Derecho / Photos Between Body and Cabin - Right Side",
      label: t('capture.cajaCabinaDerechaPhotos'),
      photos: [
        {
          type: 'caja-cabina-derecha-inferior' as const,
          label: t('photoZones.cajaCabinaDerechaInferior'),
          id: "Caja Cabina Derecha Inferior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'caja-cabina-derecha-medio' as const,
          label: t('photoZones.cajaCabinaDerechaMedio'),
          id: "Caja Cabina Derecha Medio",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'caja-cabina-derecha-superior' as const,
          label: t('photoZones.cajaCabinaDerechaSuperior'),
          id: "Caja Cabina Derecha Superior",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-caja-cabina-derecha' as const,
          label: t('photoZones.otrosCajaCabinaDerecha'),
          id: "Otros Caja Cabina Derecha",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Pegatinas / Sticker Photos",
      label: t('capture.pegatinasPhotos'),
      photos: [
        {
          type: 'pegatina-tara' as const,
          label: t('photoZones.pegatinaTara'),
          id: "Pegatina Tara",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'pegatina-altura-maxima' as const,
          label: t('photoZones.pegatinaAlturaMaxima'),
          id: "Pegatina Altura Maxima",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'pegatina-revision-extintor' as const,
          label: t('photoZones.pegatinaRevisionExtintor'),
          id: "Pegatina Revision Extintor",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'pegatina-idioma-extintor' as const,
          label: t('photoZones.pegatinaIdiomaExtintor'),
          id: "Pegatina Idioma Extintor",
          mandatory: false,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-pegatinas' as const,
          label: t('photoZones.otrosPegatinas'),
          id: "Otros Pegatinas",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Fotos Tailgate Abierto / Open Tailgate Photos",
      label: t('capture.tailgateAbiertoPhotos'),
      photos: [
        {
          type: 'foto-junta-de-estanqueidad' as const,
          label: t('photoZones.fotoJuntaDeEstanqueidad'),
          id: "Junta Estanqueidad",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'foto-eyectora-en-interior-de-caja' as const,
          label: t('photoZones.fotoEyectoraEnInteriorDeCaja'),
          id: "Eyectora Interior Caja",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'foto-eyectora-pasante' as const,
          label: t('photoZones.fotoEyectoraPasante'),
          id: "Eyectora Pasante",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'foto-trineo-parte-interior-posicion-baja' as const,
          label: t('photoZones.fotoTrineoParteInteriorPosicionBaja'),
          id: "Trineo Parte Interior Posicion Baja",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'foto-general-lateral-tailgate-abierto' as const,
          label: t('photoZones.fotoGeneralLateralTailgateAbierto'),
          id: "General Lateral Tailgate Abierto",
          mandatory: true,
          multiple: false,
          qualityCheck: false,
        },
        {
          type: 'otros-tailgate-abierto' as const,
          label: t('photoZones.otrosTailgateAbierto'),
          id: "Otros Tailgate Abierto",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
    {
      id: "Otras Fotos / Other Photos",
      label: t('capture.otrosPhotos'),
      photos: [
        {
          type: 'otros' as const,
          label: t('photoZones.otros'),
          id: "Otros",
          mandatory: false,
          multiple: true,
          qualityCheck: false,
        },
      ],
    },
  ];
